import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callUserObjective } from "../../haz-license/request/request.section";
import { dateDiffStr } from "../../../../utils/date";
import numeral from "numeral";
import lodash from "lodash";

export const createColumns = ({ props }) => {
    const { operationKey } = props;
    const refRequestDocKey = operationKey === "1" ? "08" : operationKey === "2" ? "09" : operationKey === "4" ? "10" : "11";
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () =>
                operationKey === "1"
                    ? i18n.global.t("views.report.hazLicenseS3O1")
                    : operationKey === "2"
                    ? i18n.global.t("views.report.hazLicenseS3O2")
                    : operationKey === "4"
                    ? i18n.global.t("views.report.hazLicenseS3O4")
                    : i18n.global.t("views.report.hazLicenseS3O5"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({
                list: ({ searchQuery }) =>
                    callUserObjective({ searchQuery }).then(objective => objective.filter(d => [operationKey].includes(d.key))),
                optLabel: "value"
            }),
            search: { visible: () => false, name: "refOperation.id" }
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.approveCode"),
            dataIndex: "hazLicenseDetails.refHaz.approveCode",
            dataIndexValue: ({ record }) => {
                return record.hazLicenseDetails?.map(d => d.refHaz?.approveCode).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refHazObject"),
            dataIndex: "hazLicenseDetails.refHaz.refHazObject.nameTh",
            dataIndexValue: ({ record }) => {
                return record.hazLicenseDetails?.map(d => d.refHaz?.refHazObject?.nameTh).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            width: 300
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "hazLicenseDetails.refHaz.tradeNameTh",
            dataIndexValue: ({ record }) => {
                return record.hazLicenseDetails?.map(d => d.refHaz?.tradeNameTh).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            width: 300
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: refRequestDocKey }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { visible: () => false, name: "refDepartment.id" },
            width: 200
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            //dataIndexValue: () => "1 ปี",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.quantity"),
            dataIndexValue: ({ record }) => {
                return `${numeral(record.quantity).format("0,0.00")}`
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "right",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            visible: () => ["5"].includes(operationKey),
            title: () => i18n.global.t("views.report.specificArea"),
            dataIndex: "specificArea",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["5"].includes(operationKey),
            title: () => i18n.global.t("model.hazLicense.refHazLicenseObjective"),
            dataIndex: "refHazLicenseObjective.value",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["2"].includes(operationKey),
            title: () => i18n.global.t("views.report.hazLicenseCountries"),
            dataIndexValue: ({ record }) => {
                return record.hazLicenseCountries?.map(d => d.refCountry?.nameTh).join(", ")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "left",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["1", "2", "4"].includes(operationKey),
            title: () => i18n.global.t("views.report.manufacturer"),
            dataIndexValue: ({ record }) => {
                return record.hazLicenseDetails?.map(d => d.refHaz?.manufacturer).join("\r\n")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["1", "2", "4"].includes(operationKey),
            title: () => i18n.global.t("views.report.manufactureCountry"),
            dataIndexValue: ({ record }) => {
                return record.hazLicenseDetails?.map(d => d.refHaz?.refManufactureCountry?.nameTh).join("\r\n")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["4"].includes(operationKey),
            title: () => i18n.global.t("views.report.manufactureLocationProvince"),
            dataIndexValue: ({ record }) => {
                const provinces = record.hazLicenseStorageLocations
                    ?.filter(d => !d.refStorageLocation?.isLocation)
                    ?.flatMap(d => d.refStorageLocation?.addresses || [])
                    ?.map(d => d.refProvince.nameTh) || [];
                return lodash.uniq(provinces).join(", ")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            visible: () => ["1", "2", "4", "5"].includes(operationKey),
            title: () => i18n.global.t("views.report.storageLocationProvince"),
            dataIndexValue: ({ record }) => {
                const provinces = record.hazLicenseStorageLocations
                    ?.filter(d => d.refStorageLocation?.isLocation)
                    ?.flatMap(d => d.refStorageLocation?.addresses || [])
                    ?.map(d => d.refProvince.nameTh) || [];
                return lodash.uniq(provinces).join(", ")
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
